(function(){
     'use strict';

     angular
        .module('appback')
        .factory('NovarumService', NovarumService);

    NovarumService.$inject = ['$http'];

    function NovarumService($http){

        var service= {
           guardarinterp:guardarinterp,
           downloadPDF:downloadPDF
        };

        return service;

        function guardarinterp(id,value,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               id:id,
               value:value
            });
            $http.post('/backend/info/guardarinterp', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }


        function downloadPDF(historicosm_id,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/pdf'
                }
            }
            $http.get('/backend/historicosm/downloadpdf/'+historicosm_id, { params : { } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                console.log("data received", data)
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }


      
    }
})();